/* Header submenu */
// Used with styling in header.scss
// Adds .jsMenu to #siteNavMain on load
// Adds/removes .activeNav and .activeNavCol on click/hover

const header = function(documentElem) {
  let submenuIsOpen = false;

  function initHeader() {
    const maxWidthDesk = 1200;
    const maxWidthTablet = 800;
    const maxWidthPhone = 500;
    let siteNavMain = documentElem.getElementById("siteNavMain");
    let navCols = documentElem.querySelectorAll("ul.nav-sub");
    let navTopNames = getNavTopNames();
    let currentCol = null;
    let navColOpen = false;
    let colTimeout = null;
    let submenuOn = false;
    let navColsOn = false;
    let keyNavOn = true;
    let windowWidth = window.innerWidth;

    siteNavMain.classList.add("jsMenu");
    initSubmenu();
    initNavCols();
    loadHeader(window.innerWidth);

    window.addEventListener("resize", function(e) {
      if (window.innerWidth !== windowWidth) {
        windowWidth = window.innerWidth;
        loadHeader(e.target.innerWidth);
      }
    });

    function loadHeader(width) {
      deactivateSubmenu();
      deactivateNavCols();

      if (width > maxWidthTablet && width <= maxWidthDesk) {
        activateSubmenu();
      } else if (width > maxWidthDesk) {
        activateNavCols();
      } else if (width <= maxWidthTablet) {
        activateSubmenu();
      }
    }

    // JS Tablet Size - Full Submenu
    // Submenu base interaction is styled with CSS,
    // this just adds click-to-keep-open functionality
    function initSubmenu() {
      activateSubmenu();
      siteNavMain.addEventListener("click",
      ()=> siteNavMain.classList.toggle("activeNav"));
      documentElem.addEventListener("click", closeOnClick);
      documentElem.addEventListener("keydown", closeOnEsc);
    }

    function activateSubmenu() {
      siteNavMain.classList.add("jsSubmenu");
      submenuOn = true;
    }

    function deactivateSubmenu() {
      siteNavMain.classList.remove("jsSubmenu");
      siteNavMain.classList.remove("activeNav");
      submenuOn = false;
    }

    // Close submenu on click outside of submenu/navbar area
    function closeOnClick(e) {
      if (submenuOn && !e.target.closest("#siteNavMain")) {
        siteNavMain.classList.remove("activeNav");
      }
    }

    // Close submenu on hitting escape key
    function closeOnEsc(e) {
      if (e.keyCode == 27) { // esc
        siteNavMain.classList.remove("activeNav");
      }
    }

    // JS Desktop Size - Navigation Columns
    // Section nav column appears on hover over section name
    function initNavCols() {
      activateNavCols();
      documentElem.querySelector("ul.nav").addEventListener("mouseover", openNavCol);
      documentElem.querySelector("ul.nav").addEventListener("focusin", openNavCol);
      documentElem.addEventListener("click", closeColClick);
      documentElem.querySelector("ul.nav").addEventListener("mouseout", closeColDelay);
      documentElem.querySelector("ul.nav").addEventListener("keydown", keyNav);
    }

    function activateNavCols() {
      siteNavMain.classList.add("jsNavCols");
      navColsOn = true;
    }

    function deactivateNavCols() {
      closeNavCol();
      siteNavMain.classList.remove("jsNavCols");
      clearTimeout(colTimeout);
      colTimeout = null;
      currentCol = null;
      navColsOn = false;
    }

    function getNavTopNames() {
      return [...navCols].map(col => {
        col.firstElementChild.classList.remove("nav-current");
        col.firstElementChild.classList.remove("nav-current-parent");
        return col.firstElementChild.className;
      });
    }

    function openNavCol(e) {
      if (!navColsOn) return;
      let parent = e.target.parentElement;
      let parentClass = parent.className;
      let parentLoc = parent.getBoundingClientRect();
      let navIndex = navTopNames.indexOf(parentClass);
      if (navIndex > -1) {
        closeNavCol();
        navCols[navIndex].classList.add("activeNavCol");
        currentCol = navCols[navIndex];
        currentCol.style.position = "fixed";
        currentCol.style.top = (parentLoc.y + parentLoc.bottom) + "px";
        currentCol.style.left = parentLoc.x + "px";
        currentCol.addEventListener("mouseout", closeColDelay);
      }
    }

    function closeColClick(e) {
      if (!e.target.closest("#siteNavMain")) {
        closeNavCol();
      }
    }

    function closeColDelay(e) {
      clearTimeout(colTimeout);
      colTimeout = setTimeout(function() {
        if (currentCol && !currentCol.parentNode.matches(":hover")) {
          closeNavCol();
        } else {
          closeColDelay(e);
        }
      }, 1000);
    }

    function closeNavCol() {
      clearTimeout(colTimeout);
      if (currentCol) {
        currentCol.classList.remove("activeNavCol");
        currentCol.style = null;
        currentCol.removeEventListener("mouseout", closeColDelay);
      }
    }

    function keyNav(e) {
      if (siteNavMain.classList.contains("jsNavCols")) {
        // if user starts to tab,
        // deactivate individual columns & activate submenu
        if (e.keyCode === 9 && navColsOn) { // tab
          e.preventDefault();
          e.stopPropagation();
          keyNavOn = true;
          deactivateNavCols();
          activateSubmenu();

          documentElem.addEventListener("click", ()=> {
            deactivateSubmenu();
            activateNavCols();
          }, { once: true });
        }
      }
    }

  }

  return {
    init: initHeader
  }
}
